"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

exports.__esModule = true;

var react_1 = __importDefault(require("react"));

exports.SVG = function () {
  return react_1["default"].createElement("svg", {
    viewBox: "0 0 20 20",
    fill: "none"
  }, react_1["default"].createElement("path", {
    d: "M16.498 17H3.497C3.222 17 2.998 16.776 2.997 16.501L2.988 9.499C2.988 9.223 3.212 8.999 3.488 8.999H16.489C16.765 8.999 16.988 9.223 16.989 9.498L16.998 16.499C16.998 16.775 16.774 17 16.498 17ZM17 4C17.553 4 18 4.447 18 5V6.937V17C18 17.553 17.553 18 17 18H3C2.447 18 2 17.553 2 17V5C2 4.447 2.447 4 3 4H3.748C3.886 4 3.998 4.112 3.998 4.25V5.002C3.998 6.216 5.084 7.18 6.336 6.974C7.319 6.812 7.998 5.886 7.998 4.89V4.25C7.998 4.112 8.109 4 8.248 4H11.749C11.887 4 11.999 4.112 11.999 4.25V5.002C11.999 6.216 13.086 7.181 14.337 6.974C15.32 6.812 15.999 5.886 15.999 4.89V4.25C15.999 4.112 16.11 4 16.249 4H17ZM6 2C6.553 2 7 2.447 7 3V4.959C7 5.512 6.553 5.959 6 5.959C5.447 5.959 5 5.512 5 4.959V3C5 2.447 5.447 2 6 2ZM14 2C14.553 2 15 2.447 15 3V4.959C15 5.512 14.553 5.959 14 5.959C13.447 5.959 13 5.512 13 4.959V3C13 2.447 13.447 2 14 2Z",
    fill: "#727B7F"
  }));
};